import { parseMerchantConfig, prepareCreateIntent } from './merchant-config';

/**
 * Method to remove null, undefined & empty from the object
 *
 * @param  {obj} obj - Parsed Intent data
 * @return {object} Object - return clean object
 */
const cleanObject = obj => {
  Object.keys(obj).forEach(key => {
    const val = obj[key];
    if (val && typeof val === 'object') {
      cleanObject(obj[key]);
    } else if (val === '' || val === null || val === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

/**
 * Method to extract review comments if the message length is greater than 100
 *
 * @param  {review} review - Review object from the merchant vinit param
 * @return {object} object - review data
 */
const getReviewParams = review => {
  const reviewObject = {};
  if (review) {
    if (review.message) {
      reviewObject.reviewMessage =
        review.message.length <= 100
          ? review.message
          : 'This will complete your purchase to this merchant.';
    }
    if (review.buttonAction) {
      reviewObject.buttonAction = review.buttonAction;
    }
  }
  return reviewObject;
};

const mapVinitToIntentPayload = (vInitRequest, cardBrand) => {
  const parsedMerchantConfig = parseMerchantConfig(vInitRequest, cardBrand);
  const intentData = prepareCreateIntent(parsedMerchantConfig);

  delete intentData.currencyFormat;
  delete intentData.apikey;
  delete intentData.customData;
  delete intentData.referenceCallID;

  const updatedIntentData = Object.assign({}, intentData, getReviewParams(vInitRequest.review));

  const cleanIntentData = cleanObject(updatedIntentData);
  cleanIntentData.srciProfile = false;
  return cleanIntentData;
};

export default mapVinitToIntentPayload;
